import { Feature } from '@tencent/workbench';
import { config } from './config';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import BaseToolbarFeature from '../../common/feature/base-toolbar-feature';

@Feature()
export class RotateFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;

    public rotateRight90() {
        const model = this.getSelectModel() as IElementBaseModel;
        model.getFrame?.()?.rotateByCurrent(90, true);
    }

    public rotateLeft90() {
        const model = this.getSelectModel() as IElementBaseModel;
        model.getFrame?.()?.rotateByCurrent(-90, true);
    }

    public flipVertical() {
        const model = this.getSelectModel() as IElementBaseModel;
        const currentValue = model.getFrame().getFrameInfo()?.flipV ?? 0;
        model.getFrame?.()?.updateFrame({ frame: { flipV: currentValue ^ 1 } });
    }

    public flipHorizontal() {
        const model = this.getSelectModel() as IElementBaseModel;
        const currentValue = model.getFrame().getFrameInfo()?.flipH ?? 0;
        model.getFrame?.()?.updateFrame({ frame: { flipH: currentValue ^ 1 } });
    }
}
